import React from "react";

const CONTAINER_CLASSES =
  "group relative p-[2px] bg-white-button-border-unhover rounded-full hover:bg-white-button-border-hovered transition-all duration-300";
const BUTTON_CLASSES_BASE =
  "relative flex items-center gap-2 text-white-button-text-color leading-[140%] font-medium bg-white-button-unhover-color rounded-full shadow-lg shadow-gray-700/30 transition duration-300";
const BUTTON_CLASSES_HOVER =
  "hover:bg-white-button-hovered-color hover:shadow-gray-500/50";
const BLUR_EFFECT =
  "absolute inset-0 rounded-full border-[1px] border-gray-400/50 blur-md";

const Loader = ({
  text = "Submitting...",
  type,
  padding = "px-5 py-1 md:px-6 md:py-4",
  textClassName = "text-sm md:text-lg",
  className = "",
  disabled = true,
  ariaLabel = "",
}) => {
  // Enable hover only if onClick is provided
  const buttonClasses = `${BUTTON_CLASSES_BASE} ${BUTTON_CLASSES_HOVER} ${padding}`;
  return (
    <div
      className={`${className} ${CONTAINER_CLASSES} ${
        disabled ? "opacity-70" : ""
      }`}
    >
      <button
        type={type}
        className={buttonClasses}
        disabled={disabled}
        aria-label={ariaLabel}
      >
        <div className="flex flex-row items-center space-x-4">
          <span className={textClassName}>{text}</span>
          <svg
            className="h-8 w-8 animate-spin text-black"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </div>

        <div className={BLUR_EFFECT} />
      </button>
    </div>
  );
};

export default Loader;
